"use strict";
const a = typeof FormData < "u" ? FormData : null;
export {
  a as default
};
//# sourceMappingURL=index.es415.js.map
